import React from 'react';
import PropTypes from 'prop-types';
import { generate } from 'shortid';

import {
  Icon,
  StyledWrapper,
  Text
} from 'athenaeum';

import { address, contactWrapper, header } from './styles';
import ContactItem from './ContactItem';

const Contact = (props) => {
  const { contactItems } = props;

  return (
    <StyledWrapper
      css={contactWrapper}
    >
      <StyledWrapper
        css={header}
        component={Icon}
        icon="pgLogoBlack"
      />
      <StyledWrapper
        css={address}
      >
        <Text type={10} font="b" align="left">
          50 West 23rd Street, Floor 9
        </Text>
        <Text type={10} font="b" align="left">
          New York, NY 10010
        </Text>
      </StyledWrapper>
      {
        contactItems.map(item =>
          (<ContactItem
            key={`contact-item-${generate()}`}
            item={item}
          />))
      }
    </StyledWrapper>
  );
};

Contact.propTypes = {
  contactItems: PropTypes.array
};

export default Contact;



// WEBPACK FOOTER //
// ../src/templates/Footer/Contact/index.js